<main class="container-fluid  ">
  <!--  <prettyjson [obj]="mData"></prettyjson>-->
  <div class="m-2">
    <div class="card mx-2 ">
      <div class="row mx-3">
        <mat-form-field appearance="outline" class="col-md-3 mt-2">
          <mat-label>Select Centre</mat-label>
          <mat-select [(ngModel)]="selectedCentre" #selectElement (selectionChange)="OnCentreChange($event)">
            <mat-option *ngFor=" let c of (centres$|async) " [value]="c.centreCode">{{ c.centreName }}</mat-option>
            <!--      <mat-option  value="All">All Centres</mat-option>-->
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-3 mt-2" *ngIf="mId==null">
          <mat-label>Report Type</mat-label>
          <mat-select [(ngModel)]="reportType" (selectionChange)="onReportTypeSelect($event)">
            <mat-option *ngFor=" let type of reportTypes" [value]="type">{{type}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-4 mt-2">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date">
            <input matEndDate [(ngModel)]="mEndDate" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          <!--                @if (range.controls.start.hasError('matStartDateInvalid')) {-->
          <!--                <mat-error>Invalid start date</mat-error>-->
          <!--            Education Impact Report Table    }-->
          <!--                @if (range.controls.end.hasError('matEndDateInvalid')) {-->
          <!--                <mat-error>Invalid end date</mat-error>-->
          <!--                }-->
        </mat-form-field>

        <button class="col-md-2 mt-2" mat-mini-fab color="accent" (click)="Search()">
          <mat-icon>search</mat-icon>
        </button>
<!--        <div>-->
<!--          Teachers Session : {{ mTeacherSessions }} <br>-->
<!--          Teachers Session Group : {{ mTeacherSessionsGroup }} <br>-->
<!--          Special Days Observed : {{ mDaysObserved }}<br>-->
<!--          Volunteer Session : {{ mVolunteerSessions }}<br>-->
<!--          Volunteer Session Group : {{ mVolunteerSessionsGroup }}-->
<!--        </div>-->
        <mat-form-field appearance="outline" class=" col-md-4">
          <mat-label>Total Teachers Sessions</mat-label>
          <input matInput inputmode="number" [(ngModel)]="mTeacherSessions+mTeacherSessionsGroup-mDaysObserved">
        </mat-form-field>
        <mat-form-field appearance="outline" class=" col-md-4">
          <mat-label>Total Volunteer Sessions</mat-label>
          <input matInput inputmode="number" [(ngModel)]="mVolunteerSessions+mVolunteerSessionsGroup">
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Total Special Days</mat-label>
          <input matInput inputmode="number" [(ngModel)]="mDaysObserved">
        </mat-form-field>
        <!--              <mat-form-field appearance="outline" class="col-md-4">-->
        <!--                  <mat-label>Total Admissions</mat-label>-->
        <!--                  <input matInput inputmode="number" [(ngModel)]="mTotalAdmissions">-->
        <!--              </mat-form-field>-->
        <!--              <mat-form-field appearance="outline" class="col-md-4">-->
        <!--                  <mat-label>Total Discharge</mat-label>-->
        <!--                  <input matInput inputmode="number" [(ngModel)]="mTotalDischarge">-->
        <!--              </mat-form-field>-->

      </div>


      <div class="mx-4">
        <!--                <ckeditor [editor]="Editor" [data]="editorData" (change)="onEditorChange($event)"></ckeditor>-->
        <br>
        <label>Highlights</label>
        <ckeditor
          [editor]="Editor"
          [(ngModel)]="highlights"
          style="height: 300px"
        ></ckeditor>
<!--        <p-editor [(ngModel)]="highlights" [style]="{ height: '320px' }"></p-editor>&ndash;&gt;-->




        <!--              <div class="dropdown">-->
        <!--                <button class="btn btn-secondary dropdown-toggle" type="button" id="categoryDropdown" data-bs-toggle="dropdown" aria-expanded="false">-->
        <!--                  Select Category-->
        <!--                </button>-->
        <!--                <ul class="dropdown-menu" aria-labelledby="categoryDropdown">-->
        <!--                  <li><a class="dropdown-item" href="#" (click)="selectCategory('Education Session')">Education Session</a></li>-->
        <!--                  <li><a class="dropdown-item" href="#" (click)="selectCategory('Celebration')">Celebration</a></li>-->
        <!--                  <li><a class="dropdown-item" href="#" (click)="selectCategory('Volunteering Session')">Volunteering Session</a></li>-->
        <!--                </ul>-->
        <!--              </div>-->
        <!--        <div class=" d-flex flex-column col-md-2 m-1">-->
        <!--          <label for="galleryImages">Gallery Images: </label>-->
        <!--          <button id="galleryImages" mat-raised-button color="primary" (click)="openGallery()">Upload</button>-->
        <!--        </div>-->
        <div class="text-end">

          <button mat-raised-button color="accent" class="m-2"
                  (click)="openPhotoGallery('education')"
                  matTooltip="Pick images for Education Session gallery">
            <mat-icon>school</mat-icon> Edu Gallery
          </button>
          <button mat-raised-button color="accent" class="m-2"
                  (click)="openPhotoGallery('celebration')"
                  matTooltip="Pick images for Celebration gallery">
            <mat-icon>celebration</mat-icon> Special Day Gallery
          </button>
          <button mat-raised-button color="accent" class="m-2"
                  (click)="openPhotoGallery('volunteering')"
                  matTooltip="Pick images for Volunteering Session gallery">
            <mat-icon>volunteer_activism</mat-icon> Volunteering Gallery
          </button>
          <mat-form-field appearance="outline" class="mx-2 mt-2">
            <mat-label>Select Before Submit</mat-label>
            <mat-select (selectionChange)="getValues($event)">
              <mat-option value="draft">Draft</mat-option>
              <mat-option value="final">Final</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="accent" class="m-2" (click)="save()">Submit</button>
          <button mat-raised-button color="primary" class="m-2" (click)="printDoc()">Download</button>
        </div>
      </div>

    </div>

  </div>

  <!-- ─── Education Session Gallery ─── --
  <div class="m-2">
    <div class="card mx-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <mat-icon>school</mat-icon>
          <h5 class="mb-0">Education Session Gallery</h5>
          <span *ngIf="galleryImagesEdu.length > 0"
                style="background:#673ab7;color:white;padding:4px 12px;border-radius:12px;font-size:13px;">
            {{ galleryImagesEdu.length }} image(s)
          </span>
        </div>
        <div *ngIf="galleryImagesEdu.length > 0">
          <button mat-raised-button color="accent" (click)="openPhotoGallery('education')" class="mr-2">
            <mat-icon>add</mat-icon> Add More
          </button>
          <button mat-raised-button color="warn" (click)="clearGallery('education')">
            <mat-icon>clear_all</mat-icon> Clear All
          </button>
        </div>
      </div>
      <div class="card-body">
        <div *ngIf="galleryImagesEdu.length === 0" class="text-center py-4">
          <mat-icon style="font-size:48px;width:48px;height:48px;color:#999;">photo_library</mat-icon>
          <p class="text-muted mt-2">No images selected. Click <strong>Edu Gallery</strong> to pick from session documents.</p>
        </div>
        <div *ngIf="galleryImagesEdu.length > 0" class="gallery-grid">
          <div *ngFor="let img of galleryImagesEdu; let i = index" class="gallery-item">
            <div class="image-container">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="gallery-image">
              <div class="image-overlay">
                <button mat-mini-fab color="warn" (click)="removeImageFromGallery(i,'education')" class="remove-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="image-info">
              <div class="image-filename" [title]="img.fileName">{{ img.fileName }}</div>
              <div class="image-meta" *ngIf="img.centreName"><mat-icon class="meta-icon">location_on</mat-icon>{{ img.centreName }}</div>
              <div class="image-meta" *ngIf="img.description"><mat-icon class="meta-icon">description</mat-icon>{{ img.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Celebration Gallery ─── -->
  <div class="m-2">
    <div class="card mx-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <mat-icon>celebration</mat-icon>
          <h5 class="mb-0">Celebration Gallery</h5>
          <span *ngIf="galleryImagesCelebration.length > 0"
                style="background:#e91e63;color:white;padding:4px 12px;border-radius:12px;font-size:13px;">
            {{ galleryImagesCelebration.length }} image(s)
          </span>
        </div>
        <div *ngIf="galleryImagesCelebration.length > 0">
          <button mat-raised-button color="accent" (click)="openPhotoGallery('celebration')" class="mr-2">
            <mat-icon>add</mat-icon> Add More
          </button>
          <button mat-raised-button color="warn" (click)="clearGallery('celebration')">
            <mat-icon>clear_all</mat-icon> Clear All
          </button>
        </div>
      </div>
      <div class="card-body">
        <div *ngIf="galleryImagesCelebration.length === 0" class="text-center py-4">
          <mat-icon style="font-size:48px;width:48px;height:48px;color:#999;">celebration</mat-icon>
          <p class="text-muted mt-2">No images selected. Click <strong>Celebration Gallery</strong> to pick from session documents.</p>
        </div>
        <div *ngIf="galleryImagesCelebration.length > 0" class="gallery-grid">
          <div *ngFor="let img of galleryImagesCelebration; let i = index" class="gallery-item">
            <div class="image-container">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="gallery-image">
              <div class="image-overlay">
                <button mat-mini-fab color="warn" (click)="removeImageFromGallery(i,'celebration')" class="remove-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="image-info">
              <div class="image-filename" [title]="img.fileName">{{ img.fileName }}</div>
              <div class="image-meta" *ngIf="img.centreName"><mat-icon class="meta-icon">location_on</mat-icon>{{ img.centreName }}</div>
              <div class="image-meta" *ngIf="img.description"><mat-icon class="meta-icon">description</mat-icon>{{ img.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Volunteering Session Gallery ─── -->
  <div class="m-2">
    <div class="card mx-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <mat-icon>volunteer_activism</mat-icon>
          <h5 class="mb-0">Volunteering Session Gallery</h5>
          <span *ngIf="galleryImagesVolunteering.length > 0"
                style="background:#388e3c;color:white;padding:4px 12px;border-radius:12px;font-size:13px;">
            {{ galleryImagesVolunteering.length }} image(s)
          </span>
        </div>
        <div *ngIf="galleryImagesVolunteering.length > 0">
          <button mat-raised-button color="accent" (click)="openPhotoGallery('volunteering')" class="mr-2">
            <mat-icon>add</mat-icon> Add More
          </button>
          <button mat-raised-button color="warn" (click)="clearGallery('volunteering')">
            <mat-icon>clear_all</mat-icon> Clear All
          </button>
        </div>
      </div>
      <div class="card-body">
        <div *ngIf="galleryImagesVolunteering.length === 0" class="text-center py-4">
          <mat-icon style="font-size:48px;width:48px;height:48px;color:#999;">volunteer_activism</mat-icon>
          <p class="text-muted mt-2">No images selected. Click <strong>Volunteering Gallery</strong> to pick from session documents.</p>
        </div>
        <div *ngIf="galleryImagesVolunteering.length > 0" class="gallery-grid">
          <div *ngFor="let img of galleryImagesVolunteering; let i = index" class="gallery-item">
            <div class="image-container">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="gallery-image">
              <div class="image-overlay">
                <button mat-mini-fab color="warn" (click)="removeImageFromGallery(i,'volunteering')" class="remove-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="image-info">
              <div class="image-filename" [title]="img.fileName">{{ img.fileName }}</div>
              <div class="image-meta" *ngIf="img.centreName"><mat-icon class="meta-icon">location_on</mat-icon>{{ img.centreName }}</div>
              <div class="image-meta" *ngIf="img.description"><mat-icon class="meta-icon">description</mat-icon>{{ img.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-white" #content id="preview">
    <section>
      <div style="display: flex; justify-content: flex-end;">
        <img style="height: 100px;" src="../../../../../assets/logo.png" alt="logo">
      </div>
    </section>

    <section class=" text-dark">
      <div class="text-center">
        <h2 class="mb-0"><strong>NON-FORMAL EDUCATION INTERVENTION IMPACT REPORT</strong></h2>
        <h4 class="mb-3 fw-bold ">
          <span *ngIf="mStartDate!=null && mEndDate!=null"> {{ mCentre?.centreName }}
            , {{ mStartDate|date:'dd MMMM yyyy' }} – {{ mEndDate|date:'dd MMMM yyyy' }}</span>
        </h4>
      </div>
      <div class="mx-8">
        <p style="text-align: justify; text-justify: inter-word">
          Non-formal education Intervention at Accesslife Assistance Foundation was initiated to bridge the
          gap and help
          children be in touch with their education. So that after successfully completing their treatment,
          children can have a
          co-relation with their ongoing studies despite the lapse during treatment. The baseline assessment,
          intermediate
          assessment, discharge assessment, and IEP goals are being planned and implemented by our teachers.
          From <span *ngIf="mStartDate!=null && mEndDate!=null"> {{ mStartDate|date:'dd MMMM yyyy' }}
          till {{ mEndDate|date:'dd MMMM yyyy' }}</span>
          , the following are the details for the {{ mCentre?.centreName }}
          Centre.
        </p>

        <p class="fw-bold">
          Our intervention caters to children from the age group of 04 years to 14 years.</p>

        <p style="text-align: justify; text-justify: inter-word">
          Toddlers are handled by our
          volunteers under the guidance of our teachers. Volunteers take care of various activities which are
          conducted for
          toddlers on a day-to-day basis. They overall take care of Gross Motor and Fine Motor skills.
        </p>

      </div>

      <table
        style="margin-left: 80px; width: 80%; text-align: center; border-collapse: collapse; border: 1px solid black;">
        <tr>
          <th style="padding: 10px; border: 1px solid black;"></th>
          <td style="padding: 10px; border: 1px solid black; font-weight: bold;">{{ mStartDate |date:'dd/MM/yyyy' }}
            to {{ mEndDate|date:'dd/MM/yyyy' }}
          </td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Teachers session</th>
          <td
            style="padding: 10px; border: 1px solid black;">{{ mTeacherSessions + mTeacherSessionsGroup - mDaysObserved }}
          </td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Volunteers Session</th>
          <td style="padding: 10px; border: 1px solid black;">{{ mVolunteerSessions + mVolunteerSessionsGroup }}</td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Important days observed</th>
          <td style="padding: 10px; border: 1px solid black;">{{ mDaysObserved }}</td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Total Sessions</th>
          <td
            style="padding: 10px; border: 1px solid black;">{{ mTeacherSessionsGroup + mTeacherSessions + mVolunteerSessionsGroup + mVolunteerSessions }}
          </td>
        </tr>
      </table>

      <div class="mx-8">
        <div>
          <div _ngcontent-xyl-c497="" class="font-bold" style="margin-top: 10px; font-weight: bold">Highlights:</div>
          <div style="min-height: 40px; text-align: justify; text-justify: inter-word" [innerHTML]="highlights"></div>
        </div>
      </div>
      <!-- CHART-->
      <!-- <div id='' style="page-break-after: always;" ></div> -->
      <div class="mx-8" *ngIf="mShowChart">
        <div class="">
          <div>
            <p class="text-center fw-bold" style="color:red; margin-top: 20px; text-align: center;"
               *ngIf="hasChartData">
              Note: The graphical representation is the Average Score
              of the percentage our children scored in Assessments.
              <br>
              <span *ngIf="mStartDate!=null && mEndDate!=null">
          {{ mCentre?.centreName }},
                {{ mStartDate|date:'dd MMMM yyyy' }} – {{ mEndDate|date:'dd MMMM yyyy' }}
        </span>
            </p>

            <div class="header">
              <h4>PROGRESS CHART</h4>
            </div>

            <div class="text-center">
              <div class="chart-container col-md-10 text-center"> <!-- Apply the chart-container class here -->
                <apx-chart [series]="areaChartOptions.series!" [chart]="areaChartOptions.chart!"
                           [xaxis]="areaChartOptions.xaxis!" [yaxis]="areaChartOptions.yaxis!"
                           [colors]="areaChartOptions.colors!" [stroke]="areaChartOptions.stroke!"
                           [legend]="areaChartOptions.legend!" [grid]="areaChartOptions.grid!"
                           [tooltip]="areaChartOptions.tooltip!"
                           [dataLabels]="areaChartOptions.dataLabels!"></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      <div class="row">-->
      <!--        <div class="col-md-12 marginleft" *ngIf="selectedImages.length">-->
      <!--          <h2>Educations:</h2>-->
      <!--          <div style="display: flex; flex-wrap: wrap; gap: 21px; ">-->
      <!--            <ng-container *ngFor="let image of selectedImages; let i = index">-->
      <!--              <div style="flex: 0 0 calc(20% - 10px); text-align: center;  position: relative;">-->
      <!--                <img [src]="image" alt="Selected Image" style="width: 150px; height: 150px; margin-top: 15px; border:1px solid"/>-->
      <!--                <span (click)="deleteImageFromArray(i, selectedImages)" style="cursor: pointer; position: absolute; top: 25px; right: 25px;">-->
      <!--            <i class="bi bi-trash" style="font-size: 1.2rem;"></i>-->
      <!--          </span>-->
      <!--              </div>-->
      <!--            </ng-container>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->


      <!--      <div class="row">-->
      <!--        <div class="col-md-12 marginleft" *ngIf="selectedImages1.length">-->
      <!--          <h2>Celebration:</h2>-->
      <!--          <div style="display: flex; flex-wrap: wrap; gap: 21px;">-->
      <!--            <ng-container *ngFor="let image of selectedImages1; let i = index">-->
      <!--              <div-->
      <!--                style="text-align: center; flex: 0 0 calc(20% - 10px); text-align: center;  position: relative;">-->
      <!--                <img [src]="image" alt="Selected Image" style="width: 150px; height: 150px; margin-top: 15px;border:1px solid" />-->
      <!--                <span (click)="deleteImageFromArray(i, selectedImages1)" style="cursor: pointer; position: absolute; top: 25px; right: 25px;">-->
      <!--            <i class="bi bi-trash" style="font-size: 1.2rem;"></i>-->
      <!--          </span>-->
      <!--              </div>-->
      <!--            </ng-container>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="row">-->
      <!--        <div class="col-md-12 marginleft" *ngIf="selectedImages2.length">-->
      <!--          <h2>Volunteering:</h2>-->
      <!--          <div style="display: flex; flex-wrap: wrap; gap: 21px;">-->
      <!--            <ng-container *ngFor="let image of selectedImages2; let i = index">-->
      <!--              <div-->
      <!--                style="flex: 0 0 calc(20% - 10px); text-align: center; position: relative;">-->
      <!--                <img [src]="image" alt="Selected Image" style="width: 150px; height: 150px; margin-top: 15px; border: 1px solid" />-->
      <!--                <span (click)="deleteImageFromArray(i, selectedImages2)" style="cursor: pointer; position: absolute; top: 25px; right: 25px;">-->
      <!--            <i class="bi bi-trash" style="font-size: 1.2rem;"></i>-->
      <!--          </span>-->
      <!--              </div>-->
      <!--            </ng-container>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- ══════════════ EDUCATION SESSION ══════════════ -->
      <div class="col-md-12 marginleft preview-section"
           *ngIf="selectedImagesEdu.length || galleryImagesEdu.length">
        <div class="preview-section-header">
          <span class="preview-section-dot" style="background:#673ab7;"></span>
          <h3 class="preview-section-title">Education Session</h3>
          <div class="preview-section-line"></div>
        </div>
        <div class="preview-image-grid">
          <!-- uploaded images (editable) -->
          <ng-container *ngFor="let image of selectedImagesEdu; let i = index">
            <input type="file" [id]="'eduFileInput'+i" style="display:none;"
                   (change)="onEditEducationFilesSelected($event,'education',i)" accept="image/*"/>
            <div class="preview-img-wrap">
              <img [src]="image" (click)="openImagePreview(image)" alt="Education" class="preview-img"/>
              <div class="preview-img-actions">
                <span (click)="triggerFileInput(i,'education')" title="Replace"><i class="bi bi-pencil-square"></i></span>
                <span (click)="deleteImageFromArray(i,selectedImagesEdu,'education')" title="Delete"><i class="bi bi-trash"></i></span>
              </div>
            </div>
          </ng-container>
          <!-- gallery images -->
          <ng-container *ngFor="let img of galleryImagesEdu; let i = index">
            <div class="preview-img-wrap">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
              <div class="preview-img-actions">
                <span (click)="removeImageFromGallery(i,'education')" title="Remove"><i class="bi bi-trash"></i></span>
              </div>
              <div class="preview-img-caption" *ngIf="img.centreName || img.description">
                <small>{{ img.centreName }}</small>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════════ CELEBRATION ══════════════ -->
      <div class="col-md-12 marginleft preview-section"
           *ngIf="selectedImagesCelebration.length || galleryImagesCelebration.length">
        <div class="preview-section-header">
          <span class="preview-section-dot" style="background:#e91e63;"></span>
          <h3 class="preview-section-title">Speacial Day</h3>
          <div class="preview-section-line"></div>
        </div>
        <div class="preview-image-grid">
          <ng-container *ngFor="let image of selectedImagesCelebration; let i = index">
            <input (change)="onEditCelebrationFilesSelected($event,'celebration',i)"
                   [id]="'celeFileInput'+i" accept="image/*" style="display:none;" type="file"/>
            <div class="preview-img-wrap">
              <img [src]="image" (click)="openImagePreview(image)" alt="Celebration" class="preview-img"/>
              <div class="preview-img-actions">
                <span (click)="triggerFileInput(i,'celebration')" title="Replace"><i class="bi bi-pencil-square"></i></span>
                <span (click)="deleteImageFromArray(i,selectedImagesCelebration,'celebration')" title="Delete"><i class="bi bi-trash"></i></span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngFor="let img of galleryImagesCelebration; let i = index">
            <div class="preview-img-wrap">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
              <div class="preview-img-actions">
                <span (click)="removeImageFromGallery(i,'celebration')" title="Remove"><i class="bi bi-trash"></i></span>
              </div>
              <div class="preview-img-caption" *ngIf="img.centreName || img.description">
                <small>{{ img.centreName }}</small>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════════ VOLUNTEERING SESSION ══════════════ -->
      <div class="col-md-12 marginleft preview-section"
           *ngIf="selectedImagesVolunteering.length || galleryImagesVolunteering.length">
        <div class="preview-section-header">
          <span class="preview-section-dot" style="background:#388e3c;"></span>
          <h3 class="preview-section-title">Volunteering Session</h3>
          <div class="preview-section-line"></div>
        </div>
        <div class="preview-image-grid">
          <ng-container *ngFor="let image of selectedImagesVolunteering; let i = index">
            <input type="file" [id]="'volunFileInput'+i" style="display:none;"
                   (change)="onEditVolunteeringFilesSelected($event,'volunteering',i)" accept="image/*"/>
            <div class="preview-img-wrap">
              <img [src]="image" (click)="openImagePreview(image)" alt="Volunteering" class="preview-img"/>
              <div class="preview-img-actions">
                <span (click)="triggerFileInput(i,'volunteering')" title="Replace"><i class="bi bi-pencil-square"></i></span>
                <span (click)="deleteImageFromArray(i,selectedImagesVolunteering,'volunteering')" title="Delete"><i class="bi bi-trash"></i></span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngFor="let img of galleryImagesVolunteering; let i = index">
            <div class="preview-img-wrap">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
              <div class="preview-img-actions">
                <span (click)="removeImageFromGallery(i,'volunteering')" title="Remove"><i class="bi bi-trash"></i></span>
              </div>
              <div class="preview-img-caption" *ngIf="img.centreName || img.description">
                <small>{{ img.centreName }}</small>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- Image Preview Popup -->
      <div *ngIf="showPreview"
           style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;">
        <div style="position: relative;">
          <img [src]="previewImageUrl" alt="Preview" style="max-width: 90vw; max-height: 90vh; border: 4px solid #fff; border-radius: 8px;" />
          <button (click)="closeImagePreview()"
                  style="position: absolute; top: 8px; right: 8px; background: #fff; border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 20px; cursor: pointer;">&times;</button>
        </div>
      </div>
    </section>

  </div>
</main>
